export default __webpack_public_path__ + "static/media/Bangalore.7055779a.png";